import { render, staticRenderFns } from "./role-playing-banner.vue?vue&type=template&id=7c0d6fa0&scoped=true&"
import script from "./role-playing-banner.vue?vue&type=script&lang=ts&"
export * from "./role-playing-banner.vue?vue&type=script&lang=ts&"
import style0 from "./role-playing-banner.vue?vue&type=style&index=0&id=7c0d6fa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0d6fa0",
  null
  
)

export default component.exports